module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isLoading) ? _c('div', [(_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": true,
      "fixed": true
    }
  }) : _vm._e()], 1) : (_vm.forecastWindow && _vm.items && _vm.hasAccessRead(_vm.FUNCTIONALITY)) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', [_c('DefaultButton', {
    on: {
      "click": function($event) {
        _vm.$router.push(_vm.backLink)
      }
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px 0"
    }
  }, [_c('ForecastNameBanner', {
    attrs: {
      "forecast": _vm.forecastWindow.forecast
    }
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.forecastWindow.zone.name) + " "), (_vm.isDisabledZone) ? _c('em', [_vm._v("(Deleted)")]) : _vm._e()])]), _vm._v(" "), (_vm.canExport) ? _c('div', {
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('IconButton', {
    attrs: {
      "width": '220px'
    },
    on: {
      "click": _vm.exportXls
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('ExportXlsIcon')], 1), _vm._v(" Download Results")], 2)], 1) : _vm._e()])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "page-section"
  }, [_c('CalendarInfo', {
    attrs: {
      "forecast": _vm.forecastWindow.forecast,
      "forecast-window": _vm.forecastWindow
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "page-section"
  }, [_c('Contributors', {
    attrs: {
      "forecast-window": _vm.forecastWindow
    }
  })], 1), _vm._v(" "), _c('div', [_c('Comments', {
    attrs: {
      "forecast": _vm.forecastWindow.forecast,
      "forecast-window": _vm.forecastWindow
    }
  }, [(_vm.isForecastManager || _vm.isZonesSupervisor) ? _c('div', [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.canValidate) ? _c('div', [(_vm.isZonesSupervisor) ? _c('IconButton', {
    attrs: {
      "width": '220px',
      "background-color": _vm.FORECAST_WINDOW_COLORS.VALIDATED
    },
    on: {
      "click": _vm.validate
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('TickIcon')], 1), _vm._v("\n                                Validate\n                            ")], 2) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.canReChallenge) ? _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('IconButton', {
    attrs: {
      "disabled": this.forecastWindow.forecast.status === _vm.FORECAST_STATUS.CLOSED,
      "width": '220px',
      "background-color": _vm.FORECAST_WINDOW_COLORS.RE_CHALLENGED
    },
    on: {
      "click": function($event) {
        _vm.isReChallengeModalVisible = true
      }
    }
  }, [_c('template', {
    slot: "icon"
  }, [_c('ReChallengeIcon')], 1), _vm._v("\n                                Re-challenge "), _c('span', {
    staticClass: "rechallenge-cut"
  }, [_vm._v(_vm._s(_vm.forecastWindow.zone.name))])], 2)], 1) : _vm._e()])]) : _vm._e()])], 1)]), _vm._v(" "), (_vm.forecastWindow.reChallengeMessage) ? _c('div', {
    staticClass: "notification SectionBorderTop",
    style: ({
      borderColor: _vm.FORECAST_WINDOW_COLORS.RE_CHALLENGED,
      backgroundColor: '#fff6d7'
    })
  }, [_c('div', [_c('ReChallengeIcon', {
    staticClass: "icon"
  })], 1), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "headline",
    style: ({
      color: _vm.FORECAST_WINDOW_COLORS.RE_CHALLENGED
    })
  }, [_vm._v("Forecast Re-Challenged")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [(_vm.forecastWindow.reChallengedBy) ? _c('div', [_vm._v("\n                    Re-Challenged by : " + _vm._s(_vm.forecastWindow.reChallengedBy.lastname) + ", " + _vm._s(_vm.forecastWindow.reChallengedBy.firstname) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.forecastWindow.reChallengedDate) ? _c('div', [_vm._v("Re-Challenged date : " + _vm._s(_vm.formatDate(_vm.forecastWindow.reChallengedDate)))]) : _vm._e()]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    style: ({
      color: _vm.FORECAST_WINDOW_COLORS.RE_CHALLENGED
    })
  }, [_vm._v("Message :")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-transform": "none"
    }
  }, [_c('MultiLineText', {
    attrs: {
      "text": _vm.forecastWindow.reChallengeMessage
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.showValidationPendingMessage) ? _c('div', {
    staticClass: "notification SectionBorderTop"
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v("The quantities are temporary and might change until final submission/validation")])]) : _vm._e(), _vm._v(" "), (_vm.isSubmittable || _vm.zoneReaderCanDownloadXls) ? _c('div', {
    staticClass: "row SectionBorderTop"
  }, [_c('div', {
    staticClass: "col-sm-12 "
  }, [_c('div', {
    staticClass: "export"
  }, [_c('div', {
    staticStyle: {
      "padding-top": "5px",
      "float": "right"
    }
  }, [(_vm.exportXls) ? _c('a', {
    staticClass: "elementExcel",
    on: {
      "click": _vm.exportXlsForImport
    }
  }, [_c('ExportXlsForImportIcon', {
    staticStyle: {
      "height": "50px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSubmittable) ? _c('label', {
    staticClass: "elementExcel",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "for": "myfile"
    }
  }, [_c('UploadXlsIcon', {
    staticStyle: {
      "height": "50px"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.isSubmittable) ? _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "myfile",
      "name": "myfile",
      "accept": ".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
    },
    on: {
      "change": _vm.loadFile
    }
  }) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('ForecastTable', [_c('template', {
    slot: "head-row-1"
  }, [_c('th', {
    staticClass: "text-center",
    attrs: {
      "colspan": _vm.forecastWindow.forecast.recurrenceAmount + 3 + (_vm.forecastWindow.forecast.preseriesDate ? 1 : 0)
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.forecastWindow.zone.name) + "\n                    ")])]), _vm._v(" "), _c('template', {
    slot: "head-row-2"
  }, [_c('th', [_vm._v("Item")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Est. Price")]), _vm._v(" "), (_vm.forecastWindow.forecast.preseriesDate && _vm.nonReactiveQuantitiesPreseries.length) ? _c('th', {
    staticClass: "preseries"
  }, [_vm._v("\n                        " + _vm._s(_vm.getDateByFormat(_vm.forecastWindow.forecast.preseriesDate, "MM / YYYY"))), _c('br'), _vm._v("PRESERIES\n                    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.forecastWindow.forecast.recurrenceAmount), function(recurrence) {
    return _c('th', {
      key: ("rep_amount_" + recurrence)
    }, [(_vm.forecastWindow.forecast.datesRecurrence.length) ? _c('div', [_vm._v("\n                            " + _vm._s(_vm.getDateByFormat(_vm.forecastWindow.forecast.datesRecurrence[recurrence - 1], "MM / YYYY")) + "\n                        ")]) : _vm._e()])
  })], 2), _vm._v(" "), _c('template', {
    slot: "body"
  }, [_c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', {
      key: (_vm.renderCycle + "_" + (item.id)),
      class: {
        isDisabled: _vm.isItemDisabled(item)
      }
    }, [_c('td', {
      style: (item.color != null && item.color !== '' ? 'border-left: 15px solid ' + item.color : '')
    }, [_c('ItemImage', {
      attrs: {
        "item": item
      }
    })], 1), _vm._v(" "), _c('td', [_c('ItemDescription', {
      attrs: {
        "item": item,
        "forecast": _vm.forecastWindow.forecast
      }
    })], 1), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(_vm.getPriceForItem(_vm.forecastWindow, item)))]), _vm._v(" "), (_vm.forecastWindow.forecast.preseriesDate && _vm.nonReactiveQuantitiesPreseries.length) ? _c('td', _vm._l((_vm.nonReactiveQuantitiesPreseries), function(quantity, index) {
      return (quantity && quantity.item === item.id) ? _c('div', {
        key: ("preseries_" + (item.id) + "_" + index),
        attrs: {
          "id": ("preseries_" + (item.id) + "_" + index)
        }
      }, [_c('QuantityInput', {
        attrs: {
          "value": quantity.quantity,
          "is-disabled": !_vm.isUpdatable ||
            !(_vm.isZonesForecaster || _vm.isForecastManager || _vm.isZonesSupervisor || _vm.forecastsService.isGodMode()) ||
            _vm.isObsolete(item) ||
            _vm.isCancelled(item),
          "item-id": quantity.item,
          "recurrence": quantity.recurrence,
          "index": parseInt(index)
        },
        on: {
          "update": function($event) {
            _vm.onValueUpdate($event, item.id, quantity.recurrence)
          }
        }
      })], 1) : _vm._e()
    })) : _vm._e(), _vm._v(" "), _vm._l((_vm.nonReactiveQuantities), function(quantity, index) {
      return (quantity.item === item.id) ? _c('td', {
        key: ((item.id) + "_" + index),
        staticClass: "text-left",
        attrs: {
          "id": ((item.id) + "_" + index)
        }
      }, [_c('QuantityInput', {
        attrs: {
          "value": quantity.quantity,
          "is-disabled": !_vm.isUpdatable || _vm.isObsolete(item) || _vm.isCancelled(item),
          "item-id": quantity.item,
          "recurrence": quantity.recurrence,
          "index": parseInt(index)
        },
        on: {
          "update": function($event) {
            _vm.onValueUpdate($event, item.id, quantity.recurrence)
          }
        }
      })], 1) : _vm._e()
    })], 2)
  }))])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v("\n            Estimated total: "), _c('span', {
    staticClass: "total"
  }, [_vm._v(" " + _vm._s(_vm.estimatedTotalForecastWindow))])])]), _vm._v(" "), _c('div', {
    staticClass: "comment"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Comments / Special requirements")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.forecastWindow.comment),
      expression: "forecastWindow.comment"
    }],
    attrs: {
      "disabled": !_vm.isSubmittable
    },
    domProps: {
      "value": (_vm.forecastWindow.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.forecastWindow.comment = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.isSavable || _vm.isSubmittable) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "submitBoutons",
    staticStyle: {
      "text-align": "right"
    }
  }, [(_vm.isUserSuperAdmin) ? _c('DefaultButton', {
    attrs: {
      "backgroundColor": "#727a96"
    },
    on: {
      "click": _vm.resetForecastWindow
    }
  }, [_vm._v("Reset Forecast")]) : _vm._e(), _vm._v(" "), (_vm.isSavable) ? _c('DefaultButton', {
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_vm._v("Temporary save")]) : _vm._e(), _vm._v(" "), (_vm.isSubmittable) ? _c('DefaultButton', {
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Submit Forecast")]) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isReChallengeModalVisible) ? _c('ReChallengeModal', {
    attrs: {
      "forecast": _vm.forecastWindow.forecast,
      "provided-forecast-windows": [_vm.forecastWindow]
    },
    on: {
      "closed": function($event) {
        _vm.isReChallengeModalVisible = false
      },
      "rechallenged": _vm.loadForecastWindow
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46ab09c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/ForecastWindowDetail.vue
// module id = 3156
// module chunks = 0